import { createGlobalStyle } from 'styled-components';
import fonts from '../../components/base/typography/fonts';
import media from '../media';

const GlobalStyle = createGlobalStyle`
	* {
		border: 0;
		box-sizing: inherit;
		-webkit-font-smoothing: antialiased;
		font-weight: inherit;
		margin: 0;
		/* outline: 0; */
		padding: 0;
		/* Tarf tetta ad vera? */
		/* visibility: visible; */
		text-decoration: none;
		text-rendering: optimizeLegibility;
		-webkit-appearance: none;
		-moz-appearance: none;
	}

	.svarbox__windowChatBox input[type='radio'] {
		-webkit-appearance: radio;
		-moz-appearance: radio;
	}

	html {
		font-size: 50%;

		${media.desktopLarge`
			font-size: 62.5%;
		`};
	}

	html, body {
		min-height: 100%;
	}

	img, picture {
		max-width: 100%;
	}

	body {
		max-width: 100vw;
		margin: 0;
		padding: 0;
		font-size: ${({ theme }) => theme.fonts.fontSize};
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
		line-height: ${({ theme }) => theme.fonts.lineHeight};
		background-color: #fff;
		color: ${({ theme }) => theme.colors.textColor};
		box-sizing: border-box;
        letter-spacing: .02rem;
	}

	input, textarea {
		font-family: ${({ theme }) => theme.fonts.ArimoRegular};
		outline: 0;
	}

	.js-focus-visible :focus:not(.focus-visible) {
		outline: none;
	}

	.js-focus-visible :focus:not([data-focus-visible-added]) {
		outline: none;
	}

	${fonts};

	// Watson chatbot
	#WAC__header-homeScreen > .WAC__header-avatar {
		display: none !important;
	}
	.WAC__homeScreenOriginal-body {
		background: ${({ theme }) => theme.colors.primary} url('/dist/images/njallRaw.svg') no-repeat bottom right !important;
		background-size: 160px 210px !important;
	}
	.WAC__homeScreenOriginal-greeting {
		padding-right: 80px !important;
		padding-bottom: 50px !important;
		font-size: 22px !important;
	}
`;

export default GlobalStyle;
